var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes,style:({ '--skeleton-width': _vm.width, '--skeleton-height': _vm.height })})
}
var staticRenderFns = []

export { render, staticRenderFns }